(function () {
    "use strict";

    angular
        .module("iMatApp")
        .factory("processingWorkflowService", processingWorkflowService);

    processingWorkflowService.$inject = ["$http", "$q", "$log", "poller"];

    function processingWorkflowService($http, $q, $log, poller) {
        var baseUrl = "/processing-workflows/";

        var statuses = {
            unknown: { key: 0, name: "Unknown" },
            notStarted: { key: 10, name: "NotStarted" },
            inProgress: { key: 20, name: "InProgress" },
            complete: { key: 30, name: "Complete" }
        };

        var results = {
            unknown: { key: 0, name: "Unknown" },
            succeeded: { key: 10, name: "Succeeded" },
            failed: { key: 20, name: "Failed" },
            canceled: { key: 30, name: "Canceled" }
        };

        return {
            waitProcessingWorkflowComplete: waitProcessingWorkflowComplete
        };

        function waitProcessingWorkflowComplete(workflowId, canceler) {
            var requestUrl = baseUrl + workflowId + "/status";
            var d = $q.defer();

            var workflowStatusPoller = poller.get(requestUrl, {
                delay: 750,
                argumentsArray: [workflowId],
                smart: true,
                catchError: true
            });

            if (angular.isDefined(canceler)) {
                canceler.then(function () {
                    $log.debug("ABORT wait processing workflow complete for workflowId = " + workflowId);
                    workflowStatusPoller.stop();
                    d.reject('CANCELED');
                });
            }

            workflowStatusPoller.promise.then(null, null, function (response) {
                if (response.status === 200) {
                    var statusInfo = response.data;
                    extendStatusInfo(statusInfo.state);

                    d.notify(statusInfo);

                    if (statusInfo.state.isComplete()) {
                        d.resolve(statusInfo);
                        workflowStatusPoller.stop();
                    }
                } else {
                    d.reject(response);
                    workflowStatusPoller.stop();
                }
            });

            return d.promise;
        }

        function extendStatusInfo(status) {

            var apiObject = {
                isUnknown: function () {
                    return this.key === statuses.unknown.key;
                },
                isNotStarted: function () {
                    return this.key === statuses.notStarted.key;
                },
                isInProgress: function () {
                    return this.key === statuses.inProgress.key;
                },
                isComplete: function () {
                    return this.key === statuses.complete.key;
                }
            };

            return angular.extend(status, apiObject);
        }

        function extendResultInfo(result) {
            var apiObject = {
                isUnknown: function () {
                    return this.key === results.unknown.key;
                },
                isSucceeded: function () {
                    return this.key === results.succeeded.key;
                },
                isInvalid: function () {
                    return this.key === results.invalid.key;
                },
                isFailed: function () {
                    return this.key === results.failed.key;
                },
                isAborted: function () {
                    return this.key === results.aborted.key;
                }
            };

            return angular.extend(result, apiObject);
        }
    }
}());